import { Reveal } from "@/components/site/Reveal";
import { InstagramIcon, FacebookIcon } from "@/components/site/SocialIcons";
import { useLang } from "@/lib/i18n";

export const SocialFeed = () => {
  const { t } = useLang();
  return (
  <section className="bg-linen py-24 sm:py-32" data-testid="social-feed-section">
    <div className="container-x">
      <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="eyebrow">{t("feed.eyebrow")}</p>
          <h2 className="mt-3 text-4xl font-black tracking-tight text-forest sm:text-5xl">@escamequita</h2>
          <p className="mt-4 max-w-xl text-base font-medium text-moss md:text-lg">{t("feed.text")}</p>
        </div>
        <div className="flex flex-wrap gap-3">
          <a href="https://www.instagram.com/escamequita" target="_blank" rel="noreferrer" className="btn-primary" data-testid="feed-follow-instagram"><InstagramIcon className="h-4 w-4" /> {t("feed.follow")}</a>
          <a href="https://www.facebook.com/Escamequita" target="_blank" rel="noreferrer" className="btn-outline" data-testid="feed-follow-facebook"><FacebookIcon className="h-4 w-4" /> Facebook</a>
        </div>
      </Reveal>
      <div className="mx-auto mt-12 grid max-w-3xl gap-8">
        <Reveal className="overflow-hidden rounded-2xl border border-clay bg-white">
          <iframe
            title="Escamequita Facebook page"
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FEscamequita&tabs=timeline&width=500&height=640&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
            className="mx-auto block h-[640px] w-full max-w-[500px]"
            loading="lazy"
            frameBorder="0"
            scrolling="no"
            allow="encrypted-media"
            data-testid="facebook-embed"
          />
        </Reveal>
        <Reveal delay={0.1} className="overflow-hidden rounded-2xl border border-clay bg-white">
          <iframe
            title="Escamequita Instagram feed"
            src="https://www.instagram.com/escamequita/embed"
            className="h-[640px] w-full"
            loading="lazy"
            frameBorder="0"
            scrolling="no"
            data-testid="instagram-embed"
          />
        </Reveal>
      </div>
    </div>
  </section>
  );
};
